<template>
  <div>
    <h1>Create/Edit Sub Category</h1>
    <section>
      <b-field label="Name">
        <b-input type="text" v-model="category.name" placeholder="Name" required></b-input>
      </b-field>
      <b-field label="Parent Category">
        <b-select placeholder="Select a parent category" v-model="category.parentId" expanded>
          <option
            v-for="option in parentCategories"
            :value="option.id"
            :key="option.name"
          >{{ option.name }}</option>
        </b-select>
      </b-field>
      <div class="controls">
        <button class="button is-primary" @click="saveCategory">Save</button>
        <button
          v-if="categoryId"
          class="button is-danger"
          @click="deleteCategory"
        >{{ deleteCategoryText }}</button>
      </div>
    </section>
  </div>
</template>

<script>
import { firestore } from "@/firebase";
const PARENT_CATEGORIES_COLLECTION = "ParentCategories";
const CATEGORIES_COLLECTION = "Categories";
import { ToastProgrammatic as Toast } from 'buefy'

export default {
  props: ["categoryId"],
  data() {
    return {
      deletingCategory: false,
      editingCategory: false,
      parentCategories: [],
      category: {
        name: null,
        parentId: null
      }
    };
  },
  mounted() {
    firestore.collection(PARENT_CATEGORIES_COLLECTION).onSnapshot(snapshot => {
      let parentCategories = snapshot.docs.map(d => {
        var data = d.data();
        data.id = d.id;
        return data;
      });
      this.parentCategories = parentCategories;
    });

    if (this.categoryId != null) {
      let ref = `/${CATEGORIES_COLLECTION}/${this.categoryId}`;
      firestore
        .doc(ref)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.editingCategory = true;
            let categoryData = doc.data();
            this.category.name = categoryData.name;
            this.category.parentId = categoryData.parentId;
          } else {
            Toast.open({
              message: "No such document available",
              type: "is-danger",
              duration: 3000,
              position: "is-bottom"
            });
            this.$router.go(-1);
          }
        })
        .catch(error => {
          console.log("error getting document : " + error);
        });
    }
  },
  methods: {
    saveCategory: function() {
      var dataToSave = {
        name: this.category.name,
        parentId: this.category.parentId
      };
      var saveSuccessFullHanlder = () => {
        Toast.open({
          message: "The category has been recorded",
          type: "is-success",
          duration: 3000,
          position: "is-bottom"
        });
        this.$router.go(-1);
      };
      if (this.categoryId) {
        let ref = `/${CATEGORIES_COLLECTION}`;
        firestore
          .collection(ref)
          .doc(this.categoryId)
          .update(dataToSave)
          .then(saveSuccessFullHanlder);
      } else {
        let ref = `/${CATEGORIES_COLLECTION}`;
        console.log(ref);
        firestore
          .collection(ref)
          .add(dataToSave)
          .then(saveSuccessFullHanlder)
          .catch(error => {
            console.log("Error adding hymn : " + error);
          });
      }
    },
    deleteCategory: function() {
      if (this.deletingCategory) {
        let ref = `/${CATEGORIES_COLLECTION}/`;
        firestore
          .collection(ref)
          .doc(this.categoryId)
          .delete()
          .then(() => {
            console.log("Category deleted");
            Toast.open({
              message: "The Category has been deleted",
              type: "is-success",
              duration: 3000,
              position: "is-bottom"
            });
            this.$router.go(-1);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.deletingCategory = true;
      }
    }
  },
  computed: {
    deleteCategoryText: function() {
      if (this.deletingCategory) {
        return "Confirm Delete";
      } else {
        return "Delete";
      }
    }
  }
};
</script>